import { useRouter } from 'vue-router'
let router: ReturnType<typeof useRouter>

export default () => {
  if (!router) {
    router = useRouter()
  }

  return router
};